/** Desglose mensual referencial por plan (EUR netos) */
export const planPricing = {
  bronce: {
    rotativa: 60,
    digest: 45,
    programas: 37,
    inserts: 30,
    redes: 23,
    produccion: 23,
  },
  plata: {
    rotativa: 97,
    digest: 75,
    programas: 60,
    inserts: 53,
    redes: 45,
    produccion: 45,
  },
  oro: {
    rotativa: 113,
    digest: 105,
    programas: 90,
    inserts: 75,
    redes: 83,
    produccion: 119,
  },
};

export const plansData = [
  {
    id: 'bronce',
    tag: 'Plan Bronce',
    title: 'Inbound esencial en señal y Digest',
    highlight: false,
    features: [
      '4 impactos diarios en rotativa Radio Visual (Tips Canguro, 30–45 s).',
      '2 artículos mensuales en TNO Digest (SEO consumidor y B2B).',
      '1 integración mensual rotativa en programas selectivos (TNO Business, Franquicias o Noticias TNO).',
      'Inserts gráficos en señal (lower thirds con CTA, frecuencia estándar).',
      '4 co-publicaciones en redes del ecosistema TNO.',
      'Producción TNO: edición y locución de micros + redacción SEO básica.',
    ],
    idealFor: 'Arranque en TNO: recordación en señal, autoridad en Google y presencia en redes sin despliegue completo.',
  },
  {
    id: 'plata',
    tag: 'Plan Plata',
    title: 'Tu Vida Digital sin Interrupciones',
    highlight: true,
    features: [
      'Micros en rotativa diaria (Tips Canguro) en la grilla Radio Visual 24/7.',
      '2 artículos semanales en TNO Digest (8 al mes), SEO B2B y consumidor inteligente.',
      'Presencia en 3 programas: TNO Business, Franquicias en Venezuela y Noticias TNO.',
      'Inserts gráficos en vivo: lower thirds con CTA y códigos QR dinámicos.',
      'Clips y co-publicaciones en Instagram y TikTok (TNO × Canguro).',
      'Producción integral audiovisual y editorial incluida por TNO.',
    ],
    idealFor: 'Paquete recomendado: inbound 360° con la frecuencia y el mix acordados en la propuesta integrada.',
  },
  {
    id: 'oro',
    tag: 'Plan Oro',
    title: 'Máximo alcance inbound 360°',
    highlight: false,
    features: [
      'Rotativa diaria reforzada + momentos On-Demand en programas de negocios y tecnología.',
      '4 artículos semanales en TNO Digest (16 al mes): cobertura SEO intensiva y calendario editorial dedicado.',
      'Bloques mensuales en TNO Business y Franquicias + cápsula tech recurrente en Noticias TNO.',
      'Inserts en vivo de alta frecuencia + piezas para funnels web con QR dinámico.',
      '12+ co-publicaciones y carruseles educativos alineados al Digest.',
      'Producción premium: micros, inserts, vocero por videollamada y dossier para canales de Canguro.',
    ],
    idealFor: 'Máximo ROI: dominio en señal, programas, búsqueda orgánica y redes con producción ampliada.',
  },
];

export const INVENTARIO_LABELS = {
  rotativa: 'Rotativa Tips Canguro',
  digest: 'TNO Digest (SEO)',
  programas: 'Programas selectivos',
  inserts: 'Inserts en señal',
  redes: 'Redes (TNO × Canguro)',
  produccion: 'Producción TNO',
};

export const getPlanTotal = (plan) => {
  const p = planPricing[plan.id] || {};
  const rotativa = p.rotativa || 0;
  const digest = p.digest || 0;
  const programas = p.programas || 0;
  const inserts = p.inserts || 0;
  const redes = p.redes || 0;
  const produccion = p.produccion || 0;

  return {
    rotativa,
    digest,
    programas,
    inserts,
    redes,
    produccion,
    total: rotativa + digest + programas + inserts + redes + produccion,
  };
};

export const formatEur = (amount) => `${Math.round(amount)} €`;
